/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * [description]
 *
 * @function Phaser.Math.Average
 * @since 3.0.0
 *
 * @param {number[]} values - [description]
 *
 * @return {number} [description]
 */
var Average = function (values)
{
    var sum = 0;

    for (var i = 0; i < values.length; i++)
    {
        sum += (+values[i]);
    }

    return sum / values.length;
};

module.exports = Average;



//////////////////
// WEBPACK FOOTER
// ./math/Average.js
// module id = 839
// module chunks = 0